"use client";

import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const goals = [{
  num: "01",
  title: "File a Police Report",
  desc: "Submit non-emergency incident reports online through our secure portal for faster processing and documentation."
}, {
  num: "02",
  title: "Request Records",
  desc: "Access official police records, accident reports, and background checks through our streamlined digital request system."
}, {
  num: "03",
  title: "Community Alerts",
  desc: "Sign up for real-time safety notifications, crime alerts, and emergency updates directly from the department."
}, {
  num: "04",
  title: "Anonymous Tips",
  desc: "Provide vital information to help solve crimes while maintaining your complete anonymity through our encrypted channel."
}, {
  num: "05",
  title: "Permit Applications",
  desc: "Apply for parking permits, special event licenses, and firearm registrations with our easy-to-follow online forms."
}, {
  num: "06",
  title: "Officer Commendation",
  desc: "Share positive feedback about your interactions with our officers to help us recognize excellence in service."
}];
export default function CitizenActionPortal() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll();
  return <section data-section-id="264178" id="citizen-action-portal" className="bg-background text-foreground py-20 md:py-28 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={`mb-12 md:mb-16 max-w-3xl transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-secondary text-xs md:text-sm font-default font-bold tracking-[0.2em] uppercase mb-3">
            Online Services
          </p>
          <h2 className="text-primary font-default text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
            Citizen Action Portal
          </h2>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 transition-all duration-1000 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {goals.map((goal, i) => <Card key={i} data-index={i} className="bg-card border-t-2 border-transparent hover:border-secondary transition-all duration-300 hover:-translate-y-1 shadow-md hover:shadow-lg flex flex-col h-full rounded-md">
              <CardHeader className="pb-2">
                <div className="font-mono text-5xl md:text-6xl font-black text-secondary/10 mb-4 leading-none select-none">
                  {goal.num}
                </div>
                <CardTitle className="text-lg md:text-xl font-default font-bold text-primary">
                  {goal.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground font-default text-sm md:text-base leading-relaxed">
                  {goal.desc}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}